
import svgPaths from "../../../../imports/svg-qd1swb8vwf";

interface PromptCardData {
  image: string;
  tag: string;
  description: string;
  tagPosition: { left: string }; // The tag seems to move based on the import code
}

const promptData: PromptCardData[] = [
  {
    image: "https://images.unsplash.com/photo-1563911892437-1feda0179e1b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxFbmdsaXNoJTIwa2l0Y2hlbnxlbnwxfHx8fDE3NjYwMzk4NjR8MA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    tag: "Retail",
    description: "An evocative image of an English afternoon tea table in a period drama setting, specifically reminiscent of the Queen ...",
    tagPosition: { left: "225px" }
  },
  {
    image: "https://images.unsplash.com/photo-1542320260-f8f651de8c12?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxJdGFsaWFuJTIwa2l0Y2hlbnxlbnwxfHx8fDE3NjYwMzk4NjR8MA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    tag: "Hospital",
    description: "A charming scene depicting a rustic Italian kitchen with fresh ingredients laid out for a traditional family meal, showcasing vibrant colors and warm lighting.",
    tagPosition: { left: "210px" }
  },
  {
    image: "https://images.unsplash.com/photo-1715734865682-3824ae6de6a0?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxKYXBhbmVzZSUyMHplbiUyMGdhcmRlbnxlbnwxfHx8fDE3NjYwMzk4NjR8MA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    tag: "Education",
    description: "A serene landscape featuring a Japanese zen garden, complete with meticulously raked gravel, tranquil water features, and cherry blossom trees in full bloom.",
    tagPosition: { left: "200px" }
  },
  {
    image: "https://images.unsplash.com/photo-1704018924280-96d1ab64d213?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxXaW50ZXIlMjBjYWJpbiUyMGludGVyaW9yfGVufDF8fHx8MTc2NjAzOTg2NHww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    tag: "Retail",
    description: "A cozy winter cabin interior adorned with twinkling fairy lights, a crackling fireplace, and plush blankets, evoking a sense of warmth and comfort.",
    tagPosition: { left: "225px" }
  },
  {
    image: "https://images.unsplash.com/photo-1607220868624-dd855c2839be?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxVcmJhbiUyMHN0cmVldCUyMGFydHxlbnwxfHx8fDE3NjYwMzk4NjR8MA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
    tag: "Restaurant",
    description: "A dynamic urban street art mural that captures the essence of contemporary culture, filled with bold colors and thought-provoking graffiti.",
    tagPosition: { left: "194px" }
  }
];

const Tag = ({ text, left }: { text: string, left: string }) => (
  <div className="absolute bg-[#eaf6ec] content-stretch flex gap-[4px] h-[20px] items-center justify-center px-[8px] py-[10px] rounded-[4px] top-[6px]" style={{ left }} data-name="22px">
    <div aria-hidden="true" className="absolute border border-[#6fc482] border-solid inset-0 pointer-events-none rounded-[4px]" />
    <p className="font-sans font-medium leading-[22px] relative shrink-0 text-[#165c26] text-[12px] text-nowrap whitespace-pre" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
      {text}
    </p>
  </div>
);

const Card = ({ data }: { data: PromptCardData }) => (
  <div className="h-[210px] relative rounded-[8px] shrink-0 w-[280px]">
    <div className="overflow-clip relative rounded-[inherit] size-full">
      {/* Image Container */}
      <div className="absolute bg-gray-50 h-[120px] left-1/2 overflow-clip rounded-[8px] top-[12px] translate-x-[-50%] w-[256px]">
        <div className="absolute h-[120px] left-0 top-0 w-[256px]" data-name="image">
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <img alt="" className="absolute h-[120%] left-0 max-w-none top-0 w-full object-cover" src={data.image} />
          </div>
        </div>
      </div>

      {/* Description */}
      <p className="line-clamp-3 absolute font-sans font-normal h-[74px] leading-[1.8] left-[12px] overflow-hidden text-[#475367] text-[12px] top-[140px] tracking-[0.12px] w-[252px]" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
        {data.description}
      </p>

      {/* Tag */}
      <Tag text={data.tag} left={data.tagPosition.left} />
    </div>
    <div aria-hidden="true" className="absolute border border-[#e4e7ec] border-solid inset-0 pointer-events-none rounded-[8px]" />
  </div>
);

export const AiPromptList = () => {
  return (
    <div className="content-stretch flex flex-col gap-[16px] items-start relative shrink-0 w-full">
      <div className="content-stretch flex gap-[4px] items-center relative shrink-0">
        <div className="relative shrink-0 size-[18px]" data-name="ix:ai">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 18 18">
            <g id="ix:ai">
              <path d={svgPaths.p21edb380} fill="var(--fill-0, #101928)" id="Vector" />
            </g>
          </svg>
        </div>
        <div className="flex flex-col font-sans font-extrabold justify-center leading-[0] relative shrink-0 text-[#1d2739] text-[18px] text-nowrap" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
          <p className="leading-[normal] whitespace-pre">Explore AI Prompts</p>
        </div>
      </div>

      <div className="content-stretch flex gap-[16px] items-center overflow-clip relative shrink-0 w-full">
        {promptData.map((data, index) => (
          <Card key={index} data={data} />
        ))}
      </div>
    </div>
  );
};

